<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_iran-nuclear-sites-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_iran-nuclear-sites-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.60064224278734;"
  >
    <div
      id="g-p3_iran-nuclear-sites-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_iran-nuclear-sites-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:2.3809%;margin-top:-9.1px;left:7.1979%;width:172px;"
    >
      <p class="g-pstyle0">Attacked in Israeli airstrike</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.7492%;margin-top:-9.1px;left:7.5198%;width:175px;"
    >
      <p class="g-pstyle0">Mining and fuel processing</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.1175%;margin-top:-9.1px;left:7.2977%;width:178px;"
    >
      <p class="g-pstyle0">Research and development</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.6679%;margin-top:-9.1px;left:7.1259%;width:101px;"
    >
      <p class="g-pstyle0">Power reactor</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:36.2657%;margin-top:-14.2px;left:5.4737%;width:130px;"
    >
      <p class="g-pstyle1">Bonab Atomic Energy</p>
      <p class="g-pstyle1">Research Center</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.6795%;margin-top:-7.5px;left:39.9554%;width:187px;"
    >
      <p class="g-pstyle2">Tehran Nuclear Research Center</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.3176%;margin-top:-7.5px;right:70.3882%;width:93px;"
    >
      <p class="g-pstyle3">Lashkar Ab&rsquo;ad</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.1377%;margin-top:-7.5px;left:40.1858%;width:151px;"
    >
      <p class="g-pstyle2">Parchin Military Complex</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.05%;margin-top:-7.5px;left:35.1109%;width:178px;"
    >
      <p class="g-pstyle2">Fordow Fuel Enrichment Plant</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:49.6891%;margin-top:-21px;right:79.9632%;width:67px;"
    >
      <p class="g-pstyle4">Arak</p>
      <p class="g-pstyle4">Nuclear</p>
      <p class="g-pstyle4">Complex</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.3283%;margin-top:-7.5px;left:40.1858%;width:169px;"
    >
      <p class="g-pstyle2">Natanz Enrichment Complex</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:56.8331%;margin-top:-14.2px;left:63.7165%;width:93px;"
    >
      <p class="g-pstyle1">Saghand</p>
      <p class="g-pstyle1">Uranium Mine</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.9252%;margin-top:-14.2px;right:64.8062%;width:117px;"
    >
      <p class="g-pstyle4">Isfahan Nuclear</p>
      <p class="g-pstyle4">Technology Center</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:61.7475%;margin-top:-14.2px;left:56.3343%;width:112px;"
    >
      <p class="g-pstyle1">Yazd Radiation</p>
      <p class="g-pstyle1">Processing Center</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:66.8438%;margin-top:-14.2px;right:58.7545%;width:122px;"
    >
      <p class="g-pstyle3">Ardakan Yellowcake</p>
      <p class="g-pstyle3">Production Plant</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:69.3341%;margin-top:-11.9px;left:58.976%;margin-left:-37px;width:74px;"
    >
      <p class="g-pstyle5">Iran</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:75.2164%;margin-top:-14.2px;right:69.6387%;width:105px;"
    >
      <p class="g-pstyle3">Bushehr Nuclear</p>
      <p class="g-pstyle3">Power Plant</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.3615%;margin-top:-21px;left:70.1759%;width:106px;"
    >
      <p class="g-pstyle1">Bandar Abbas</p>
      <p class="g-pstyle1">Uranium</p>
      <p class="g-pstyle1">Production Plant</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_iran-nuclear-sites-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.82258064516129;"
  >
    <div
      id="g-p3_iran-nuclear-sites-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_iran-nuclear-sites-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.6393%;margin-top:-9.2px;left:3.7739%;width:193px;"
    >
      <p class="g-pstyle0">Attacked in Israeli airstrike</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.6393%;margin-top:-9.2px;left:49.7896%;width:112px;"
    >
      <p class="g-pstyle0">Power reactor</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5103%;margin-top:-9.2px;left:3.9823%;width:197px;"
    >
      <p class="g-pstyle0">Mining and fuel processing</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.5103%;margin-top:-9.2px;left:49.6793%;width:200px;"
    >
      <p class="g-pstyle0">Research and development</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.911%;margin-top:-14.2px;left:16.9119%;width:130px;"
    >
      <p class="g-pstyle1">Bonab Atomic Energy</p>
      <p class="g-pstyle1">Research Center</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.4674%;margin-top:-7.5px;left:42.5358%;width:187px;"
    >
      <p class="g-pstyle2">Tehran Nuclear Research Center</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:40.0803%;margin-top:-7.5px;right:65.152%;width:93px;"
    >
      <p class="g-pstyle3">Lashkar Ab&rsquo;ad</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:42.1771%;margin-top:-7.5px;left:42.707%;width:151px;"
    >
      <p class="g-pstyle2">Parchin Military Complex</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.0803%;margin-top:-7.5px;left:38.9357%;width:178px;"
    >
      <p class="g-pstyle2">Fordow Fuel Enrichment Plant</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.4997%;margin-top:-7.5px;right:72.2113%;width:137px;"
    >
      <p class="g-pstyle4">Arak Nuclear Complex</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.2416%;margin-top:-7.5px;left:42.707%;width:169px;"
    >
      <p class="g-pstyle2">Natanz Enrichment Complex</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.5642%;margin-top:-7.5px;right:61.07%;width:200px;"
    >
      <p class="g-pstyle4">Isfahan Nuclear Technology Center</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.5642%;margin-top:-7.5px;left:60.193%;width:141px;"
    >
      <p class="g-pstyle1">Saghand Uranium Mine</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.79%;margin-top:-7.5px;left:54.7072%;width:190px;"
    >
      <p class="g-pstyle1">Yazd Radiation Processing Center</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.2739%;margin-top:-7.5px;right:50.9465%;width:209px;"
    >
      <p class="g-pstyle3">Ardakan Yellowcake Production Plant</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.6338%;margin-top:-13.3px;left:56.6977%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle5">Iran</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.4997%;margin-top:-7.5px;right:64.481%;width:169px;"
    >
      <p class="g-pstyle3">Bushehr Nuclear Power Plant</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.5239%;margin-top:-14.2px;left:64.9931%;width:153px;"
    >
      <p class="g-pstyle1">Bandar Abbas</p>
      <p class="g-pstyle1">Uranium Production Plant</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_iran-nuclear-sites-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.94285714285714;"
  >
    <div
      id="g-p3_iran-nuclear-sites-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_iran-nuclear-sites-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.5948%;margin-top:-9.2px;left:2.9474%;width:193px;"
    >
      <p class="g-pstyle0">Attacked in Israeli airstrike</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.5948%;margin-top:-9.2px;left:3.1084%;width:197px;"
    >
      <p class="g-pstyle0">Mining and fuel processing</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.5948%;margin-top:-9.2px;left:38.1084%;width:200px;"
    >
      <p class="g-pstyle0">Research and development</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.7377%;margin-top:-9.2px;left:73.866%;width:112px;"
    >
      <p class="g-pstyle0">Power reactor</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.3687%;margin-top:-14.6px;left:21.362%;width:148px;"
    >
      <p class="g-pstyle1">Bonab Atomic Energy</p>
      <p class="g-pstyle1">Research Center</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.083%;margin-top:-7.6px;left:44.0088%;width:214px;"
    >
      <p class="g-pstyle2">Tehran Nuclear Research Center</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.7973%;margin-top:-7.6px;right:62.7604%;width:105px;"
    >
      <p class="g-pstyle3">Lashkar Ab&rsquo;ad</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.7973%;margin-top:-7.6px;left:44.1603%;width:172px;"
    >
      <p class="g-pstyle2">Parchin Military Complex</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:44.7973%;margin-top:-7.6px;left:40.827%;width:204px;"
    >
      <p class="g-pstyle2">Fordow Fuel Enrichment Plant</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:47.2259%;margin-top:-7.6px;right:69.0487%;width:156px;"
    >
      <p class="g-pstyle4">Arak Nuclear Complex</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.083%;margin-top:-7.6px;left:44.1603%;width:193px;"
    >
      <p class="g-pstyle2">Natanz Enrichment Complex</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.3687%;margin-top:-7.6px;right:59.1276%;width:230px;"
    >
      <p class="g-pstyle4">Isfahan Nuclear Technology Center</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.3687%;margin-top:-7.6px;left:59.6148%;width:161px;"
    >
      <p class="g-pstyle1">Saghand Uranium Mine</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.6544%;margin-top:-7.6px;left:54.7664%;width:218px;"
    >
      <p class="g-pstyle1">Yazd Radiation Processing Center</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.2259%;margin-top:-7.6px;right:50.2557%;width:240px;"
    >
      <p class="g-pstyle3">Ardakan Yellowcake Production Plant</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.5093%;margin-top:-15.6px;left:52.9941%;margin-left:-49.5px;width:99px;"
    >
      <p class="g-pstyle5">Iran</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.5116%;margin-top:-7.6px;right:62.2681%;width:193px;"
    >
      <p class="g-pstyle3">Bushehr Nuclear Power Plant</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:80.6544%;margin-top:-14.6px;left:63.8573%;width:175px;"
    >
      <p class="g-pstyle1">Bandar Abbas</p>
      <p class="g-pstyle1">Uranium Production Plant</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 18:07 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 18:07 -->
<!-- ai file: p3_iran-nuclear-sites.ai -->
<style lang="scss">
  #g-p3_iran-nuclear-sites-box,
  #g-p3_iran-nuclear-sites-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_iran-nuclear-sites-box p {
    margin: 0;
  }
  #g-p3_iran-nuclear-sites-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_iran-nuclear-sites-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_iran-nuclear-sites-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_iran-nuclear-sites-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_iran-nuclear-sites-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_iran-nuclear-sites-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-p3_iran-nuclear-sites-md {
        display: block !important;
      }
    }
  }
  #g-p3_iran-nuclear-sites-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_iran-nuclear-sites-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_iran-nuclear-sites-xs .g-pstyle0 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_iran-nuclear-sites-xs .g-pstyle1 {
    height: 14px;
  }
  #g-p3_iran-nuclear-sites-xs .g-pstyle2 {
    font-weight: 500;
    height: 14px;
    color: rgb(165, 15, 21);
  }
  #g-p3_iran-nuclear-sites-xs .g-pstyle3 {
    height: 14px;
    text-align: right;
  }
  #g-p3_iran-nuclear-sites-xs .g-pstyle4 {
    font-weight: 500;
    height: 14px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-p3_iran-nuclear-sites-xs .g-pstyle5 {
    font-weight: 900;
    line-height: 22px;
    height: 22px;
    letter-spacing: 0.2em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p3_iran-nuclear-sites-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_iran-nuclear-sites-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_iran-nuclear-sites-sm .g-pstyle0 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
  }
  #g-p3_iran-nuclear-sites-sm .g-pstyle1 {
    height: 14px;
  }
  #g-p3_iran-nuclear-sites-sm .g-pstyle2 {
    font-weight: 500;
    height: 14px;
    color: rgb(165, 15, 21);
  }
  #g-p3_iran-nuclear-sites-sm .g-pstyle3 {
    height: 14px;
    text-align: right;
  }
  #g-p3_iran-nuclear-sites-sm .g-pstyle4 {
    font-weight: 500;
    height: 14px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-p3_iran-nuclear-sites-sm .g-pstyle5 {
    font-weight: 900;
    line-height: 25px;
    height: 25px;
    letter-spacing: 0.2em;
    font-size: 20px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-p3_iran-nuclear-sites-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_iran-nuclear-sites-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_iran-nuclear-sites-md .g-pstyle0 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 16px;
  }
  #g-p3_iran-nuclear-sites-md .g-pstyle1 {
    height: 14px;
  }
  #g-p3_iran-nuclear-sites-md .g-pstyle2 {
    font-weight: 500;
    height: 14px;
    color: rgb(165, 15, 21);
  }
  #g-p3_iran-nuclear-sites-md .g-pstyle3 {
    height: 14px;
    text-align: right;
  }
  #g-p3_iran-nuclear-sites-md .g-pstyle4 {
    font-weight: 500;
    height: 14px;
    text-align: right;
    color: rgb(165, 15, 21);
  }
  #g-p3_iran-nuclear-sites-md .g-pstyle5 {
    font-weight: 900;
    line-height: 29px;
    height: 29px;
    letter-spacing: 0.2em;
    font-size: 26px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
